import React, { useEffect } from 'react';

const BusinessAccountInputView = (props: any) => {
    const { inputProps } = props;
    // List of fields that need to be mandatory
    const mandatoryFieldsArray: string[] = ['company_addressstreetnumber', 'company_addressphone'];

    useEffect(() => {
        if (mandatoryFieldsArray.includes(inputProps.props.id)) {
            const inputElement = document.querySelector(`input#${inputProps.props.id}`);
            if (inputElement) {
                inputElement.setAttribute('aria-required', 'true');
            }
        }
    });

    return <div>{inputProps}</div>;
};

export default BusinessAccountInputView;
